import apiWrapper from "Helpers/apiWrapper";
import { encodeParams } from "mailup-react-helpers";

const endpoints = ((baseURL: string) => {
	/* eslint-disable prettier/prettier */
	return {
		downloadImportFile: (idList: number, fileName: string) =>
			`${baseURL}/list/${encodeURIComponent(idList)}/import/download/${encodeURIComponent(fileName)}`,
		uploadImportFile: (idList: number) =>
			`${baseURL}/list/${encodeURIComponent(idList)}/import/upload`,
		deleteImportFile: (idList: number) =>
			`${baseURL}/list/${encodeURIComponent(idList)}/import/delete`,
		getImportFiles: (idList: number, qsParams: FspGetImportFilesParams) =>
			`${baseURL}/list/${encodeURIComponent(idList)}/import/files?${encodeParams(qsParams) as string}`,
    downloadImportExampleFile: () => `${baseURL}/import/download/example`
	};
	/* eslint-enable prettier/prettier */
})(process.env.BEFSP_URL as string);

export const beFspDownloadImportFile = async (
	idList: number,
	fileName: string,
): Promise<FspFileObj> => {
	const url = endpoints.downloadImportFile(idList, fileName);
	return await apiWrapper({
		method: "get",
		url,
		headers: {
			"Content-Type": "application/json",
		},
	}).then(({ data }) => data);
};

export const beFspDownloadImportExampleFile = async (): Promise<FspFileObj> => {
	const url = endpoints.downloadImportExampleFile();
	return await apiWrapper({
		method: "get",
		url,
		headers: {
			"Content-Type": "application/json",
		},
	}).then(({ data }) => data);
};

export const beFspUploadImportFile = async (
	idList: number,
	data: FspFileObj,
): Promise<FspFileResp> => {
	const url = endpoints.uploadImportFile(idList);
	return await apiWrapper({
		method: "post",
		data: JSON.stringify(data),
		headers: {
			"Content-Type": "application/json",
		},
		url,
	}).then(({ data }) => data);
};

export const beFspDeleteImportFile = async (
	idList: number,
	data: FspFileNames,
): Promise<FspResp> => {
	const url = endpoints.deleteImportFile(idList);
	return await apiWrapper({
		method: "post",
		data: JSON.stringify(data),
		url,
		headers: {
			"Content-Type": "application/json",
		},
	}).then(({ data }) => data);
};

export const beFspGetImportFiles = async (
	idList: number,
	qsParams: FspGetImportFilesParams,
): Promise<GetImportFilesResp> => {
	const url = endpoints.getImportFiles(idList, qsParams);
	return await apiWrapper({
		method: "get",
		url,
		headers: {
			"Content-Type": "application/json",
		},
	}).then(({ data }) => data);
};

export interface FspFileObj {
	FileName: string;
	FileContent: string;
}

export interface FspFileResp {
	Url: string;
  FileName: string
  Path: string
}

export interface FspFileNames {
	FileNames: string[];
}

export interface FspResp {
	Result: boolean;
}

export interface GetImportFilesResp {
	ImportedFiles: FspFileItem[];
	TotalCount: number;
}

export interface FspFileItem {
	Name: string;
	Path: string;
	CreationTime: string;
	Size: number;
	Extension: string;
}

export interface FspGetImportFilesParams {
	pageSize?: number;
	pageNumber?: number;
	orderBy?: string;
	orderDescending?: boolean;
}
